import { Component } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ProductCsvDownloadComponent } from '../product-csv-download/product-csv-download.component';
import { AnalyticsMixpanelService } from '../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-product-download-r10',
	styleUrls: ['../product-csv-download/product-csv-download.component.css'],
	templateUrl: './product-download-r10.component.html'
})
export class ProductDownloadR10Component extends ProductCsvDownloadComponent {
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		super(analyticsService, analyticsDataModel, analyticsMixpanelService);
	}
}
